import moment from "moment";
import React from "react";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";

const format = "DD MMM YYYY"
const formatCompareDMY = "YYYYMMDD"
const formatCompareMY = "YYYYMM"
const formatCompareY = "YYYY"
const mapAboutDays = (startDate , endDate) =>{

    if (moment(startDate).format(formatCompareDMY) === moment(endDate).format(formatCompareDMY)){
        return <>
            <span> {moment(startDate).format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareMY) === moment(endDate).format(formatCompareMY)){
        return <>
            <span> {moment(startDate).format("DD")} </span> -
            <span> {moment(endDate).format(format)} </span>
        </>
    }
    if (moment(startDate).format(formatCompareY) === moment(endDate).format(formatCompareY)){
        return <>
            <span> {moment(startDate).format("DD MMM")} </span> -
            <span> {moment(endDate).format(format)} </span>
        </>
    }
    return <>
        <span> {moment(startDate).format("DD MMM YYYY")} </span> -
        <span> {moment(endDate).format("DD MMM YYYY")} </span>
    </>
}
export const mapTitleDate = (type , startDate , endDate)=>{

    switch (type){
        case KeyConstant.TODAY:
        case KeyConstant.YESTERDAY:
            return  moment(startDate).format("dddd, DD MMMM").charAt(0).toUpperCase() +
                moment(startDate).format("dddd, DD MMMM").slice(1)
        case KeyConstant.THIS_MONTH:
        case KeyConstant.LAST_MONTH:
            return moment(startDate).format("MMMM").charAt(0).toUpperCase() +
                moment(startDate).format("MMMM").slice(1)
        default :
            return mapAboutDays(startDate, endDate)
    }
}
